import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { GeneralOrganizationSettings } from '../../../components/general-organization-settings'

function GeneralOrganizationSettingsWrapper({ onToggle }) {
  return <GeneralOrganizationSettings onToggle={onToggle} />
}

export const generalOrganizationSettingsWrapper = createNgReactBridgeDirective(
  'reactGeneralOrganizationSettings',
  [],
  GeneralOrganizationSettingsWrapper,
  ['onToggle']
)
